<template>
  <div class="fields__field fields__field--input fields__field--number" :class="{ '-error': error && !value }">
    <div class="field__label">
      <label class="control-label bold" :for="identifier">{{ label }}</label>
    </div>
    <div class="field__input">
      <span class="decrease" :class="{'-disabled': value === 1}" @click="$emit('decreaseValue')">-</span>
      <input :id="identifier" class="display" :class="{ '-filled': value }" type="text" :name="identifier" :value="value" @change="$emit('updateValue', parseInt($event.target.value))">
      <span class="increase" @click="$emit('increaseValue')">+</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['identifier', 'label', 'value', 'error', 'disabled'],
}
</script>
